import { AbstractApi } from '../abstract-api';
import { BannerApi, GraphQLApi } from './endpoints';

export class ContentApi extends AbstractApi {
  public graphQl = new GraphQLApi(this.params);

  public banner = new BannerApi(this.params);
}
